<script>
    import Slider from './slider.svelte';

    const TextBlock = [
        {
            number: '650',
            title: '+ Companies',
            descrption: 'Our alumni have started 650+ companies so far',
        },
        {
            number: '3100',
            title: '+ Heroes',
            descrption: 'DraperU heroes are spread across 101 countries',
        },
        {
            number: '700',
            title: '+ New Jobs',
            descrption: 'Alumni accelerate upward mobility around the globe',
        },
        {
            number: '$900M',
            title: '+ Raised',
            descrption: 'Our companies have raised from top global investors',
        },
    ];
    const TextBlock2 = [
        {
            number: '650+',
            title: 'Companies',
            descrption: 'Our alumni have started 650+ companies so far',
        },

        {
            number: '70000+',
            title: ' New Jobs',
            descrption:
                'Our alumni are accelerating upward mobility around the globe',
        },
        {
            number: '31000+',
            title: ' Heroes',
            descrption: 'DraperU heroes are spread across 101 countries',
        },
        {
            number: '$900M+',
            title: ' Raised',
            descrption: 'Our companies have raised from top global investors',
        },
    ];
</script>

<div class='container-flu'>
    <div class="heading desktop">
        {#each TextBlock as data}
            <div class="text_block">
                <h1>
                    <span>{data.number}</span>
                    {data.title}
                </h1>
                <p class="fw-light" style="font-size:1.389vw;">
                    {data.descrption}
                </p>
            </div>
        {/each}
    </div>
    <div class="mobile-version">
        {#each TextBlock2 as data}
            <div class="mobile_text_block">
                <h1>
                    <span>{data.number}</span>
                    {data.title}
                </h1>
                <p class="fw-light">
                    {data.descrption}
                </p>
            </div>
        {/each}
        <div class="cards">
            <img alt='' width="100%" src='/images/duSuccessfulAlumniCompanyLogos/landing_mbl.svg'>
        </div>
    </div>
    <hr class="hr" />
    <div class="mobile-version">
        <p class="p">
            We inspire people and accelerate ideas by igniting the
            entrepreneurial spirit globally.
        </p>

    </div>
    <div class="desktop">
        <Slider />
    </div>
</div>

<style>

    .cards {
        width: 92.523vw;
         margin-top: 8.879vw;
    }
    .p {
        font-family: Manrope;
        font-size: 3.738vw;
        font-weight: 300;
        line-height: 5.841vw;
        letter-spacing: 0em;
        text-align: center;
        color: #ffffff;
        width: 75.935vw;
        height: 11.682vw;
        margin-top: 6vw;
        margin-left: 3vw;
        margin-bottom: 10vw;
    }

   
    .heading {
        display: flex;
        padding-top: 2vw;
        justify-content: space-around;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .cards {
        width: 90vw;
        margin: 4vw auto;
    }
        .mobile-version {
            display: flex !important;
            align-items: center;
            flex-direction: column;
        }
        .mobile_text_block {
            width: 50vw !important;
            text-align: center;
            color: white;
            margin-top: 4vw;
        }

        .mobile_text_block h1 {
            font-size: 3.505vw !important;
            color: white;

            font-family: Inter;

            font-weight: 600;
            line-height: 4.206vw;
            letter-spacing: 0em;

            text-align: center;
        }
        .mobile_text_block p {
            font-family: Inter;
            font-size: 3.271vw !important;
            font-weight: 300;
            line-height: 3.958vw;
            width: 47.897vw;
            letter-spacing: 0em;
            text-align: center;
            color: rgba(255, 255, 255, 1);
            margin-right: 0vw;
        }
        .mobile_text_block h1 span {
            color: #f7e05f;
            font-family: Inter;
            font-size: 4.439vw;
            font-weight: 600;
            line-height: 5.374vw;
            letter-spacing: 0em;
        }
    }

    .mobile-version {
        display: none;
    }
    .container-flu {
        background-color: #3c74c0;
        padding: 2vw 0vw;
        margin-top: 3.378vw;
        height: auto;
    }
    .text_block {
        width: 17.9vw;
        text-align: center;
        color: white;
    }
    .text_block h1 span {
        color: #f7e05f;
        font-size: 2.646vw;
    }
    .text_block h1 {
        font-size: 1.984vw;
        color: white;
        font-weight: 600;
    }
    .text_block p {
        font-size: 1vw;
    }
    .hr {
        color: #f7e05f;
        opacity: 1;
        height: 0.1vw;
        margin-top: 2.692vw;
        width: 84.346vw;
        margin-left: 7.009vw
    }
</style>
